const EDIT_FAQ_DRAFT_PREFIX = 'admin:faqDraft:edit:'
export const NEW_FAQ_DRAFT_KEY = 'admin:faqDraft:new'
export const FAQ_IMAGE_FILE_ACCEPT = 'image/png, image/jpeg, image/jpg'
export const FAQ_IMAGE_FILE_ERROR_MESSAGE = 'png, jpg, jpeg 파일만 업로드 가능합니다.'

const FAQ_DRAFT_FIELDS = [
    'category',
    'title',
    'content',
    'status',
    'order',
]

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const parseNumberValue = (value, fallbackValue) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

// FAQ 이미지 업로드에서 허용하는 확장자와 MIME 타입을 같은 기준으로 검사한다.
export const isFaqImageFile = (file) => {
    return Boolean(file) && (
        (file.type && ['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) ||
        /\.(png|jpe?g)$/i.test(file.name || '')
    )
}

// FAQ 폼에서 다시 입력 비용이 큰 값만 sessionStorage에 남긴다.
export const createFaqDraftPayload = ({ data = {} }) => {
    return {
        data: {
            category: data.category ?? 1,
            title: data.title || '',
            content: data.content || '',
            status: data.status ?? 1,
            order: data.order ?? 0,
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 작성 흐름을 이어간다.
export const applyFaqDraft = ({ baseData = {}, draft }) => {
    if (!draft) {
        return {
            data: baseData,
        }
    }

    const draftData = draft.data || {}
    const nextData = {
        ...baseData,
    }

    FAQ_DRAFT_FIELDS.forEach((field) => {
        if (draftData[field] === undefined) {
            return
        }

        if (field === 'category' || field === 'status' || field === 'order') {
            nextData[field] = parseNumberValue(draftData[field], baseData[field] ?? (field === 'category' ? 1 : 0))
            return
        }

        nextData[field] = draftData[field]
    })

    return {
        data: nextData,
    }
}

export const createEditFaqDraftKey = (faqId) => `${EDIT_FAQ_DRAFT_PREFIX}${faqId}`

export const readFaqDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveFaqDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearFaqDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
